import React from 'react';
import PropTypes from 'prop-types';

import competitionMeetImage from 'assets/images/uicc.png';
import styles from './DashboardLayout.module.css';

// Top banner for the dashboard pages, in two styles:
// - variant="hero" (club dashboard only): compact hero with the meet pages' image + dark overlay, season kicker over the
//   club name, so the club's home page shares the site's visual language.
// - default "classic" (personal dashboards: My Athlete Results / My Volunteer Status): white title card with the page
//   icon + title on the left (season kicker above) and member/club info on the right.
const DashboardLayout = ({
  children,
  variant,
  title,
  userName,
  clubName,
  seasonName,
}) => {
  return (
    <div className={styles.container}>
      {variant === 'hero' ? (
        <div
          className={styles.hero}
          style={{
            backgroundImage: `linear-gradient(rgba(15,23,42,0.78), rgba(15,23,42,0.92)), url(${competitionMeetImage})`,
          }}
        >
          {seasonName && <div className={styles.heroKicker}>{seasonName}</div>}
          <h1 className={styles.heroTitle}>{clubName}</h1>
        </div>
      ) : (
        <div className={styles.pageHeader}>
          <div className={styles.headerContent}>
            <div>
              {seasonName && (
                <div className={styles.seasonKicker}>{seasonName}</div>
              )}
              <div className={styles.headerTitle}>
                <span className={styles.icon}>📊</span>
                <h1>{title}</h1>
              </div>
            </div>
            <div className={styles.memberInfo}>
              {userName && <div className={styles.memberName}>{userName}</div>}
              <div>{clubName}</div>
            </div>
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['classic', 'hero']),
  title: PropTypes.string,
  userName: PropTypes.string,
  clubName: PropTypes.string,
  seasonName: PropTypes.string,
};

export default DashboardLayout;
